<template>
    <div v-observe-visibility="visibilityChanged">
        <v-layout row justify-center>
            <v-dialog v-model="removeDialog" persistent max-width="350">
                <v-card>
                    <v-card-title class="headline">Delete item?</v-card-title>
                    <v-card-text>This action deletes selected item from Database, be carefull!</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary darken-1" flat @click.native="removeDialog = false">Cancel</v-btn>
                        <v-btn color="primary darken-1" flat
                               @click.native="removeItem(itemToDelete)">OK
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

        <v-layout row wrap>
            <v-flex xs12 sm12 md6 lg3 pa-4 mt-3>
                <v-hover>
                    <v-card slot-scope="{ hover }"
                            :class="`elevation-${hover ? 4 : 1}`">
                        <v-flex xs12>
                            <v-flex xs12 pt-4 pb-3 pr-2 pl-4>
                                <span class="title">Brand Mail Settings</span>
                            </v-flex>
                            <v-divider></v-divider>
                            <v-progress-linear class="branch-office-loading" :active="loading"
                                               :indeterminate="true"></v-progress-linear>
                        </v-flex>
                        <v-list class="branchOfficesList" two-line subheader>
                            <template v-for="(item, index) in items">
                                <v-list-tile ripple avatar
                                             @click="editItem(index)">
                                    <v-list-tile-avatar>
                                        <v-icon>business_center</v-icon>
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{item.name}}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title>{{item.smtp_server}} - {{item.smtp_port}} - {{item.smtp_sec_proto}}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-btn icon ripple @click="showDeleteDialog(index)">
                                            <v-icon color="red lighten-1">delete</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-divider></v-divider>
                            </template>
                        </v-list>
                        <v-flex v-if="items == null || items.length <= 0">
                            <v-card-text><p class="text-xs-center grey--text">No Brand Mail Settings yet</p>
                            </v-card-text>
                        </v-flex>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn mt-5 dark color="secondary" @click="addNewItem">Add
                                <v-icon class="white--text" right>add</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-hover>
            </v-flex>

            <v-flex xs12 md12 lg9 pa-4 mt-3>

                <v-hover>
                    <v-card v-show="!formDisabled"
                            slot-scope="{ hover }"
                            :class="`elevation-${hover ? 4 : 1}`">
                        <v-form ref="form" v-model="formValidation" lazy-validation>
                        <v-layout wrap>
                                <v-flex xs12 md4 pt-2 pl-4 pr-4>
                                    <v-flex xs12 pt-3 pb-2>
                                        <span class="title">General</span>
                                        <v-divider></v-divider>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field :disabled="formDisabled"
                                                      v-model="selectedItem.name"
                                                      label="Name">
                                        </v-text-field>
                                    </v-flex>
                                </v-flex>
                                <v-flex xs12 md4 pt-2 pl-4 pr-4>
                                    <v-layout wrap>
                                        <v-flex xs12 pt-3 pb-2>
                                            <span class="title">Outgoing</span>
                                            <v-divider></v-divider>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-autocomplete :disabled="formDisabled"
                                                            :items="['SMTP']"
                                                            label="Mail Driver"
                                                            value="SMTP"
                                                            required
                                            ></v-autocomplete>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field :disabled="formDisabled"
                                                          v-model="selectedItem.smtp_server"
                                                          label="SMTP Host">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field :disabled="formDisabled"
                                                          v-model="selectedItem.smtp_port"
                                                          label="SMTP Port"
                                                          type="number"
                                                          :min="1"
                                                          :max="65535"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-autocomplete :disabled="formDisabled"
                                                            :items="['TLS', 'SSL']"
                                                            v-model="selectedItem.smtp_sec_proto"
                                                            label="Mail Encryption"
                                                            required
                                            ></v-autocomplete>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field :disabled="formDisabled"
                                                          v-model="selectedItem.smtp_user"
                                                          label="SMTP User">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field
                                                    :append-icon="showPW ? 'visibility_off' : 'visibility'"
                                                    :type="showPW ? 'text' : 'password'"
                                                    @click:append="showPW = !showPW"
                                                    :disabled="formDisabled"
                                                    v-model="selectedItem.smtp_password"
                                                    label="SMTP Password"
                                                    :rules="passwordConfirmationRules"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field
                                                    :append-icon="showPW ? 'visibility_off' : 'visibility'"
                                                    :type="showPW ? 'text' : 'password'"
                                                    @click:append="showPW = !showPW"
                                                    :disabled="formDisabled"
                                                    v-model="confirmPW"
                                                    label="Confirm SMTP Password"
                                                    :rules="passwordConfirmationRules"
                                            >
                                            </v-text-field>
                                        </v-flex>

                                    </v-layout>
                                </v-flex>
                                <v-flex xs12 md4 pt-2 pl-4 pr-4>
                                    <v-layout wrap>
                                        <v-flex xs12 pt-3 pb-2>
                                            <span class="title">Incoming</span>
                                            <v-divider></v-divider>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>

                        </v-layout>
                        </v-form>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn :disabled="formEdited" mt-5 class="secondary white--text"
                                   @click.native="saveAndGoToNextTab(3)">Save
                                <v-icon class="white--text" right>save</v-icon>
                            </v-btn>
                        </v-card-actions>

                    </v-card>
                </v-hover>

            </v-flex>
        </v-layout>

    </div>
</template>


<script>
    import {
        BrandConfigurationMailSetting,
        BrandConfiguration,
        Settings
    } from '../../../store/namespace-helper'

    export default {
      components: {},
      name: 'brand-configuration-mail-settings',
      data () {
        return {
          countries: this.$store.getters.countries,
          isVisible: false,
          removeDialog: false,
          itemToDelete: null,
          onDismissed: false,
          formUpdated: 0,
          formDisabled: true,
          uploadedDocument: null,
          showPW: false,
          confirmPW: null,
          formValidation: false,
          passwordConfirmationRules: [
            (v) => (v === this.selectedItem.smtp_password || this.confirmPW === undefined) || 'Passwords must match'
          ]
        }
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab visible, load data')
              this.loadItems()
            } else {
              this.formDisabled = true
              this.formUpdated = 0
              this.$store.dispatch(BrandConfigurationMailSetting.actions.setSelectedBrandConfigurationMailSettings, null)
              console.log('Brand Branch Offices not visible!!!')
            }
          }
        },
        loadItems () {
          this.$store.dispatch(BrandConfigurationMailSetting.actions.loadBrandConfigurationMailSettings)
        },
        editItem (index) {
          this.formDisabled = false
          this.$store.dispatch(BrandConfigurationMailSetting.actions.setSelectedBrandConfigurationMailSettings, this.items[index])
        },
        showDeleteDialog (index) {
          this.removeDialog = true
          this.itemToDelete = index
        },
        removeItem (index) {
          this.removeDialog = false
          this.$store.dispatch(BrandConfigurationMailSetting.actions.removeItem, this.itemToDelete)
          this.formUpdated = 0
          this.formDisabled = true
        },
        addNewItem () {
          let item = {
            id: null,
            name: 'New Brand Mail Setting',
            smtp_server: null,
            smtp_sec_proto: null,
            smtp_port: null,
            smtp_user: null,
            smtp_password: null
          }
          this.$store.dispatch(BrandConfigurationMailSetting.actions.setSelectedBrandConfigurationMailSettings, item)
          this.$store.dispatch(BrandConfigurationMailSetting.actions.addNewItem, item)
        },
        saveAndGoToNextTab (index) {
          if (!this.$refs.form.validate()) {
            return
          }
          this.$store.dispatch(BrandConfigurationMailSetting.actions.saveBrandConfigurationMailSettings, this.items)
          this.formUpdated = 0
          this.confirmPW = null
        }

      },
      computed: {
        selectedItem () {
          return this.$store.getters[BrandConfigurationMailSetting.getters.getSelectedBrandConfigurationMailSettings]
        },
        selectedBrandConfiguration () {
          return this.$store.getters[BrandConfiguration.getters.getSelectedBrandConfiguration]
        },
        items () {
          return this.$store.getters[BrandConfigurationMailSetting.getters.brandConfigurationMailSettings]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        formEdited () {
          console.log('formEdited: ' + this.formUpdated)
          return this.formUpdated < 2
        }
      },
      watch: {
        items: {
          handler (val) {
            console.log('form data changed: ' + JSON.stringify(val))
            this.formUpdated++
          },
          deep: true
        }

      }
    }
</script>

<style scoped>
    .branchOfficesList {
        max-height: 50vh;
        overflow: scroll;
        margin-top: -20px;
    }

    .branchOfficesList::-webkit-scrollbar {
        display: none;
    }

    .branch-office-loading {
        margin-top: 0px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Settings/BrandConfiguration/BrandConfigurationMailSettings.vue